import {
  getPropertyInvitedMemberCollectionRef,
  getPropertyInvitedMemberRef,
  getPropertyMemberCollectionRef,
  getPropertyMemberRef,
  getPropertyRef,
  getUserRef,
} from "../../../firebase/collectionReferences";
import {
  addDoc,
  arrayRemove,
  deleteDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { sendInvitationEmail } from "./memberSettingApi";

export async function getPropertyMembers(propertyId) {
  const propertyRef = getPropertyRef(propertyId);
  const propertyMemberRef = getPropertyMemberCollectionRef(propertyRef);
  const propertyMemberQuery = query(
    propertyMemberRef,
    orderBy("createdAt", "asc")
  );

  const invitedPropertyMemberRef =
    getPropertyInvitedMemberCollectionRef(propertyRef);
  const invitedPropertyMemberQuery = query(
    invitedPropertyMemberRef,
    orderBy("createdAt", "asc")
  );

  const members = await getDocs(propertyMemberQuery);
  const invitedMembers = await getDocs(invitedPropertyMemberQuery);

  return [
    ...members.docs.map((member) => ({ ...member.data(), id: member.id })),
    ...invitedMembers.docs.map((invitedMember) => ({
      ...invitedMember.data(),
      invited: true,
      id: invitedMember.id,
    })),
  ];
}

export async function deleteMember(memberId, propertyId) {
  const propertyRef = getPropertyRef(propertyId);
  const invitedMemberRef = getPropertyInvitedMemberRef(propertyRef, memberId);
  await deleteDoc(invitedMemberRef);
}

export async function inviteMember(data) {
  const {
    propertyId,
    email,
    role,
    invitedBy,
    invitedById,
    propertyName,
    sendEmail,
  } = data;
  const propertyRef = getPropertyRef(propertyId);
  const invitedMemberRef = getPropertyInvitedMemberCollectionRef(propertyRef);
  const member = await addDoc(invitedMemberRef, {
    email,
    role,
    invitedBy,
    invitedById,
    createdAt: serverTimestamp(),
  });

  if (sendEmail) {
    sendInvitationEmail({ email, propertyName, propertyId });
  }
  return member.id;
}

export async function updateMember(data) {
  const { propertyId, id, role, admins } = data;
  const propertyRef = getPropertyRef(propertyId);
  const propertyMemberRef = getPropertyMemberRef(propertyRef, id);
  await updateDoc(propertyMemberRef, { role });
  return id;
}

export async function removeMember(memberId, propertyId) {
  const userRef = getUserRef(memberId);
  const propertyRef = getPropertyRef(propertyId);
  const invitedMemberRef = getPropertyMemberRef(propertyRef, memberId);
  await deleteDoc(invitedMemberRef);
  await updateDoc(userRef, {
    assigned_property_ids: arrayRemove(propertyId),
  });
}
